import React, { useState, useEffect, useRef } from 'react';
import {
  TextField,
  Button,
  FormControlLabel,
  Checkbox,
  InputAdornment,
  Box,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Input,
} from '@mui/material';
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
// import bgImage from "../../../components/authentication/assets/img/bg1.jpg";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import MuiLink from "@mui/material/Link";
import Typography from "@mui/material/Typography";
import Link from "@mui/material/Link";
import Divider from "@mui/material/Divider";
import { GoogleLogin } from "@react-oauth/google";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { Helmet } from "react-helmet";
import Zippyops from "src/icons/zippy.png";
import Logo from "src/components/Logo";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import backgroundImage from "../../../components/authentication/assets/img/bg1.jpg";
import Avatar from "@mui/material/Avatar";
import Snackbar from "@mui/material/Snackbar";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Alert from "@mui/material/Alert";
import Tooltip from '@mui/material/Tooltip';
import InfoIcon from '@mui/icons-material/Info';

const SignUpPage = () => {

  const [rememberMe, setRememberMe] = useState(false);

  const handleSetRememberMe = () => setRememberMe(!rememberMe);

  const [state, setState] = useState({
    email: "",
    username: "",
    password: "",
    password2: "",
    errorMessage: "",
    submitted: false,
  });

  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [confirmpassword, setConfirmPassword] = useState("");
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [isSignInEnabled, setIsSignInEnabled] = useState(false);
  const [openredirect, setOpenredirect] = React.useState(false);

  useEffect(() => {
    const passwordsMatch = password === confirmpassword;
    const isPasswordComplexEnough = checkPasswordComplexity(password);
    setIsSignInEnabled(passwordsMatch && isPasswordComplexEnough);
  }, [password, confirmpassword]);

  const handlePasswordChange = (e) => {
    const { id, value } = e.target;
    const filteredValue = value.replace(/\s+/g, '');
    setPassword(filteredValue);
  };

  const handleTogglePasswordVisibility = () => {
    setShowPassword((prevShowPassword) => !prevShowPassword);
  };

  const handleConfirmPasswordChange = (e) => {
    const { id, value } = e.target;
    const filteredValue = value.replace(/\s+/g, '');
    setConfirmPassword(filteredValue);
  };

  const handleToggleConfirmPasswordVisibility = () => {
    setShowConfirmPassword((prevShowConfirmPassword) => !prevShowConfirmPassword);
  };

  const checkPasswordComplexity = (password) => {
    const minLength = 8;
    const hasUppercase = /[A-Z]/.test(password);
    const hasLowercase = /[a-z]/.test(password);
    const hasNumber = /[0-9]/.test(password);
    const hasSpecialCharacter = /[!@#$%^&*()_+{}\[\]:;<>,.?~\\/-]/.test(password);

    return (
      password.length >= minLength &&
      hasUppercase &&
      hasLowercase &&
      hasNumber &&
      hasSpecialCharacter
    );
  };

  const isButtonDisabled = !(
    state.username &&
    state.email &&
    password &&
    isSignInEnabled
  );

  const handleChange = (e) => {
    const { id, value } = e.target;
    let filteredValue = value;
    if (id === 'username') {
      filteredValue = value.replace(/[^a-zA-Z0-9]/g, '');
    }
    else {
      filteredValue = value.replace(/\s+/g, '');
    }
    setState((prevState) => ({
      ...prevState,
      [id]: filteredValue,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setState({ submitted: true });
    if (password !== confirmpassword) {
      setState({ errorMessage: "The passwords doesn't match" });
    } else {
      const register = {
        email: state.email,
        username: state.username,
        password: password,
      };
      fetch(`${process.env.REACT_APP_API_URL}/auth/register/`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(register),
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.email && data.username) {
            handleClickOpenconfirm();
          } else {
            setState({ email: "" });
            setState({ username: "" });
            setPassword("");
            setConfirmPassword("");
            setState({ submitted: false });
            setVisible(true);
            setOpenerror(true);
            if (data.username) {
              setState({ email: "" });
              setState({ username: "" });
              setPassword("");
              setConfirmPassword("");
              setState({ errorMessage: data.username[0] });
              setOpenerror(true);
              setVisible(true);
            } else if (data.email) {
              setOpenerror(true);
              setState({ email: "" });
              setState({ username: "" });
              setPassword("");
              setConfirmPassword("");
              setState({ errorMessage: data.email[0] });
              setOpenerror(true);
              setVisible(true);
            } else if (data.password) {
              setOpenerror(true);
              setState({ email: "" });
              setState({ username: "" });
              setPassword("");
              setConfirmPassword("");
              setState({ errorMessage: data.password[0] });
              setOpenerror(true);
              setVisible(true);
            } else {
              setOpenerror(true);
              setState({ email: "" });
              setState({ username: "" });
              setPassword("");
              setConfirmPassword("");
              setState({ errorMessage: data.errors.email[0] });
              setOpenerror(true);
              setVisible(true);
            }
          }
        })
        .catch((error) => {
          console.error(error);
          localStorage.removeItem("token");
        });
    }
  };

  const [visible, setVisible] = useState(true);
  const onDismiss = () => setVisible(false);
  let status = "register";
  const CLIENT_ID = `${process.env.REACT_APP_CLIENTID}`;
  // const CLIENT_ID = '916827922929-j0iv3hlvrrma9a1roe7ldte0gh50hiug.apps.googleusercontent.com'
  const responseGoogle = (response) => {
    // console.log("-------response-----------", response);
    const google = {
      auth_token: response.credential,
    };
    setState({ submitted: true });
    fetch(`${process.env.REACT_APP_API_URL}/social_auth/google/${status}`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(google),
    })
      .then((response) => response.json())
      .then((data) => {
        // console.log("-------------------------data--------------------", data);
        if (data.detail === "You are already registered with google, please use google authentication") {
          // console.log("step-3");
          setState({ errorMessage: data.detail });
          // console.log("-------------data detail--------------------", data.detail);
          setVisible(true);
          setOpenerror(true);

        } else {
          localStorage.setItem("user", data.username);
          localStorage.setItem("email", data.email);
          localStorage.setItem("group", data.group);
          localStorage.setItem("token", data.tokens.access);
          localStorage.setItem("google", "google");
          if (data.tokens.access) {
            // console.log("-------------------------data--------------------", data);
            window.location.href = "/app/dashboard";
          } else {
            setState({ submitted: false });
            if (data.email) {
              setState({ email: "" });
              setState({ username: "" });
              setState({ password: "" });
              setState({ password2: "" });
              setState({ errorMessage: data.email[0] });
              setVisible(true);
            } else {
              // console.log("step-3");
              setState({ errorMessage: data.detail });
              // console.log("-------------data detail--------------------", data.detail);
              setVisible(true);
              setOpenerror(true);
            }
          }
        }
      })
      .catch((error) => {
        console.error(error);
        localStorage.removeItem("token");
      });
  };

  // console.log("email",localStorage.getItem("email"));
  // console.log("token",localStorage.getItem("token"));

  const failureGoogle = (response) => {
    console.log(response);
  };
  const googleButton = useRef(null);


  const [openerror, setOpenerror] = React.useState(false);
  const handleClose = (event, reason) => {
    setOpenerror(false);
  };

  const [buttonDisabled, setButtonDisabled] = React.useState(true);
  const [openconfirm, setOpenconfirm] = React.useState(false);

  const handleClickOpenconfirm = () => {
    setOpenconfirm(true);
  };


  return (
    <>
      <Helmet>
        <title>LabAsService</title>
      </Helmet>
      {openredirect && <Navigate to="/admin" />}
      <Box
        position="absolute"
        top={0}
        left={0}
        zIndex={1}
        width="100%"
        minHeight="100vh"
        sx={{
          backgroundImage: `url(${backgroundImage})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      />
      {state.errorMessage && !state.submitted && (
        <React.Fragment>
          <Snackbar
            anchorOrigin={{
              vertical: "top",
              horizontal: "right",
            }}
            open={openerror}
            autoHideDuration={6000}
            onClose={handleClose}
            message="Note archived"
            style={{ paddingTop: "40px", paddingRight: "30px" }}
            action={
              <React.Fragment>
                <IconButton
                  size="small"
                  aria-label="close"
                  color="inherit"
                  onClick={handleClose}
                >
                  <CloseIcon fontSize="small" />
                </IconButton>
              </React.Fragment>
            }
            maxSnack={3}
          >
            <Alert onClose={handleClose} isOpen={visible} toggle={onDismiss} severity="error">
              {state.errorMessage}
            </Alert>
          </Snackbar>
        </React.Fragment>
      )}
      <Box px={1} width="100%" height="100vh" mx="auto" position="relative" zIndex={2}>
        <Grid container spacing={1} justifyContent="center" alignItems="center" height="101%">
          <Grid item xs={11} sm={9} md={5} lg={4} xl={3}>
            <Card>
              <Box
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
                mx={2}
                mt={1}
                p={-3}
                mb={-2}
                textAlign="center"
              >
                <img
                  style={{
                    width: "50%",
                    height: "50%",
                    //class: "center",
                    marginLeft: "auto",
                    marginRight: "auto",
                    display: "block",
                  }}
                  alt="..."
                  src={
                    require("../../../assets/img/labasservice1.png").default
                  }
                />

                <Typography variant="h4" fontWeight="medium" color="black" mt={1} mb={1} style={{ marginBottom: "-15px" }}>
                  Join us using
                </Typography>
                <Grid container spacing={2} justifyContent="center" sx={{ mt: 1, mb: 1 }}>
                  <Grid item xs={12} sx={{ display: "flex", justifyContent: "center" }}>
                    {/* <Typography
                      component={MuiLink}
                      href="https://www.google.com/signin"
                      variant="body1"
                      color="white"
                    >
                    </Typography> */}
                    {/* <div id='google-login-btn'>
                      <div ref={googleButton} id='google-ref'></div>
                      {/* <div>
                        <div>
                          <label>Email Id:</label>
                          <label id='email_id'></label>
                        </div>
                        <div>
                          <label>Auth token:</label>
                          <label id='auth_token'></label>
                        </div>
                      </div> */}
                    {/* </div> */}
                    <GoogleOAuthProvider
                      className="loginBtn loginBtn--google"
                      onClick={responseGoogle}
                      clientId={CLIENT_ID}
                      color="default"
                      style={{
                        width: "200px",
                        height: "50px",
                        marginBottom: "10px",
                      }}
                    >
                      <GoogleLogin onSuccess={responseGoogle} onError={failureGoogle} />
                    </GoogleOAuthProvider>
                  </Grid>
                  <Grid item xs={12}>
                    <Divider
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        fontWeight: "medium",
                        fontSize: "2px",
                        backgroundColor: "black",
                        width: "80%",
                        marginLeft: "35px",
                      }}
                    >
                      {/* <Typography variant="h5" fontWeight="medium" color="white">
                        or
                      </Typography> */}
                    </Divider>
                  </Grid>
                  <Typography
                    variant="h6"
                    fontWeight="medium"
                    color="black"
                    mt={1}
                    style={{ marginLeft: "20px", marginBottom: "10px" }}
                  >
                    Sign Up with Credentials
                  </Typography>
                </Grid>
              </Box>
              <Box pt={4} pb={3} px={3}>
                <Box component="form" role="form">
                  <Box mb={2}>
                    <TextField
                      position="relative"
                      bottom="10px"
                      variant="outlined"
                      required
                      fullWidth
                      id="email"
                      name="email"
                      autoComplete="email"
                      placeholder="Email"
                      value={state.email}
                      onChange={handleChange}
                      validate={{
                        email: {
                          value: true,
                          errorMessage: "Please enter a valid email id",
                        },
                      }}
                      autoFocus
                    />
                    {/* <input type="name" label="Name" onChange={handleNameChange} fullWidth required/> */}
                  </Box>
                  <Box mb={2}>
                    <TextField
                      position="relative"
                      bottom="25px"
                      variant="outlined"
                      required
                      fullWidth
                      name="username"
                      placeholder="Name"
                      type="text"
                      id="username"
                      value={state.username}
                      autoComplete="username"
                      onChange={handleChange}
                      autoFocus
                    />
                    {/* <input type="email" label="Email" onChange={handleEmailChange} fullWidth required /> */}
                  </Box>
                  {/* <Box mb={2} style={{ marginTop: "20px"}}>
                    <FormControl fullWidth required>
                      <InputLabel htmlFor="country-select" style={{ marginLeft: "-10px"}} shrink>
                        Country
                      </InputLabel>
                      <Select
                        value={selectedCountry}
                        onChange={handleCountryChange}
                        input={<Input id="country-select" />}
                        displayEmpty
                        required
                      >
                        <MenuItem value="" disabled>
                          &nbsp;&nbsp;Select the Country
                        </MenuItem>
                        {countries.map((country) => (
                          <MenuItem key={country.name} value={country.name}>{country.name}</MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Box>
                  <Box mb={2} display="flex" alignItems="center">
                    <TextField label="Code" value={countryCode} disabled sx={{ mr: 2 }} />
                    <TextField label="Mobile Number" value={mobile} onChange={handleMobileChange} required fullWidth />
                  </Box> */}
                  <Box mb={2}>
                    <TextField
                      fullWidth
                      label="Password"
                      value={password}
                      onChange={handlePasswordChange}
                      type={showPassword ? 'text' : 'password'}
                      required
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <Tooltip placement="top"
                              title={
                                <div>
                                  <div><span style={{ whiteSpace: 'nowrap' }}>Min character length is 8</span></div>
                                  <div><span style={{ whiteSpace: 'nowrap' }}>At least one uppercase letter</span></div>
                                  <div><span style={{ whiteSpace: 'nowrap' }}>At least one lowercase letter</span></div>
                                  <div><span style={{ whiteSpace: 'nowrap' }}>At least one number</span></div>
                                  <div><span style={{ whiteSpace: 'nowrap' }}>At least one special character</span></div>
                                </div>
                              }>
                              <InfoIcon style={{ cursor: 'pointer', marginRight: '8px' }} />
                            </Tooltip>
                            {showPassword ? (
                              <VisibilityOff
                                onClick={handleTogglePasswordVisibility}
                                style={{ cursor: 'pointer' }}
                              />
                            ) : (
                              <Visibility
                                onClick={handleTogglePasswordVisibility}
                                style={{ cursor: 'pointer' }}
                              />
                            )}
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Box>
                  <Box mb={2}>
                    <TextField
                      fullWidth
                      label="Confirm Password"
                      value={confirmpassword}
                      onChange={handleConfirmPasswordChange}
                      type={showConfirmPassword ? 'text' : 'password'}
                      required
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            {showConfirmPassword ? (
                              <VisibilityOff
                                onClick={handleToggleConfirmPasswordVisibility}
                                style={{ cursor: 'pointer' }}
                              />
                            ) : (
                              <Visibility
                                onClick={handleToggleConfirmPasswordVisibility}
                                style={{ cursor: 'pointer' }}
                              />
                            )}
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Box>
                  {/* <Typography variant="caption" color="text" style={{ whiteSpace: 'nowrap'}}>
                      Note : Password must be at least 8 characters long and include at
                    </Typography>
                    <Typography variant="caption" color="text" style={{ whiteSpace: 'nowrap'}}>
                      least one uppercase letter, one lowercase letter, one number, and
                    </Typography>
                    <Typography variant="caption" color="text" style={{ whiteSpace: 'nowrap'}}>
                      one special character.
                    </Typography>  */}
                  {/* <Box mb={2}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={agreeChecked}
                          onChange={handleAgreeCheckboxChange}
                          color="primary"
                        />
                      }
                      label="Yes, I understand and agree"
                    />
                  </Box> */}
                  <Box mt={1} mb={1}>
                    <Button
                      simple
                      onClick={handleSubmit}
                      fullWidth
                      variant="contained"
                      //   style={{ color: "#ffffff", backgroundColor: "#e91e63" }}
                      size="lg"
                      disabled={isButtonDisabled}>
                      Create Account
                    </Button>
                  </Box>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      fontWeight: "bold",
                      fontSize: "14px",
                      color: "black",
                      // fontFamily: "Open Sans",
                      fontWeight: 400,
                    }}
                  >
                    <a>
                      Already on <strong>LabAsService</strong>?&nbsp;{" "}
                    </a>
                    <Link href="admin">
                      <h3>
                        {" "}
                        <small>Sign in</small>{" "}
                      </h3>
                    </Link>
                  </div>
                  <Link
                    color="primary"
                    href="https://www.zippyops.com/contact-us"
                    target="_blank"
                    // fontFamily="sans-serif"
                    textAlign="center"
                    marginLeft="auto"
                    marginRight="auto"
                    display="block"
                    fontSize="14px"
                  >
                    <a>Contact us</a>
                  </Link>

                  <br />

                  <Grid
                    md={12}
                    style={{
                      position: "relative",
                      bottom: "10px",
                    }}
                  ></Grid>
                  <div>
                    <p
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        fontWeight: "bold",
                        fontSize: "17px",
                        color: "black",
                        // fontFamily: "Open Sans",
                        fontWeight: 400,
                      }}
                    >
                      &copy; {1900 + new Date().getYear()} ZippyOPS Consulting
                      Services LLP
                    </p>
                  </div>
                </Box>
              </Box>
            </Card>
          </Grid>
        </Grid>
      </Box>
      <div
        style={{ alignItems: "center", display: "flex", width: "411px" }}
      >
        <Dialog
          open={openconfirm}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
            <strong
              style={{ color: "rgb(8 217 42)", paddingLeft: "110px" }}
            >
              Registration Successful
            </strong>
          </DialogTitle>
          <Box
            sx={{
              alignItems: "center",
              display: "flex",
              flexDirection: "column",
              height: 180,
              width: 411,
            }}
          >
            <Avatar
              src={<Logo />}
              sx={{
                height: 170,
                width: 170,
              }}
            >
              <img alt="Logo" src={Zippyops} style={{ height: "170px" }} />
            </Avatar>
          </Box>
          <DialogContent>
            <DialogContentText
              id="alert-dialog-description"
              style={{
                fontSize: "small",
                alignItems: "center",
                paddingLeft: "80px",
              }}
            >
              Your verification mail has been sent,
            </DialogContentText>
            <DialogContentText
              id="alert-dialog-description"
              style={{ paddingLeft: "50px" }}
            >
              <strong>Please verify the mail with in 24hrs!!!</strong>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Link href="admin">
              <Button color="primary" autoFocus>
                Ok
              </Button>
            </Link>
          </DialogActions>
        </Dialog>
      </div>
    </>
  );
};

export default SignUpPage;
